"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.parse = exports.ProductPublishedStatus = exports.ProductPublishedStatusAttributes = exports.PartialProductPublishedStatusAttributes = exports.ContentConfig = exports.RequiredProductPublishedStatusAttributes = exports.ProductPublishedStatusKey = exports.PublishedStatus = void 0;
const S = __importStar(require("@effect/schema/Schema"));
const tenantId_1 = require("./datatypes/tenantId");
const productId_1 = require("./datatypes/productId");
exports.PublishedStatus = S.Literal('published', 'unpublished');
exports.ProductPublishedStatusKey = S.Struct({
    id: S.String,
});
exports.RequiredProductPublishedStatusAttributes = S.Struct({
    productId: S.String.pipe(S.fromBrand(productId_1.ProductId)),
    tenant: S.String.pipe(S.fromBrand(tenantId_1.TenantId)),
});
exports.ContentConfig = S.Struct({
    '360': S.optional(S.String),
    studio: S.optional(S.Array(S.String)),
    thumbnail: S.optional(S.Array(S.String)),
});
/**
 * For all product published-status items, we assume that if a published status
 * isn't present at any point of checking, that status is considered
 * 'unpublished'
 */
exports.PartialProductPublishedStatusAttributes = S.partial(S.Struct({
    aspect: exports.PublishedStatus,
    '3dxInspiration': exports.PublishedStatus,
    '3dxConfiguration': exports.PublishedStatus,
    content: exports.PublishedStatus,
    contentConfig: exports.ContentConfig,
}));
exports.ProductPublishedStatusAttributes = S.extend(exports.RequiredProductPublishedStatusAttributes, exports.PartialProductPublishedStatusAttributes);
/**  A single status entry in the database */
exports.ProductPublishedStatus = S.extend(exports.ProductPublishedStatusKey, exports.ProductPublishedStatusAttributes);
exports.parse = S.decodeUnknownEither(exports.ProductPublishedStatus);
